import { useMemo } from "react";
import { z } from "zod";
import { validateDepositAmount } from "utilities/Wallet/walletUtilities";
import { useFiatCurrency } from "@/hooks/firestore/user/useFiatCurrency";
import { useDepositLimits } from "@/hooks/firestore/user/useDepositLimits";
import { useIsProfileIomRegulatedMarketUnverified } from "@/hooks/firestore/user/useProfile";

const useDepositAmountValidationSchema = () => {
  const currency = useFiatCurrency();
  const { isProfileIomRegulatedMarketUnverified } =
    useIsProfileIomRegulatedMarketUnverified();

  const { depositLimit: limits, isLoading: loading } =
    useDepositLimits(currency);

  const schema = useMemo(
    () =>
      z.object({
        amount: z
          .number({ error: "Deposit amount should not be empty" })
          .superRefine((value, ctx) => {
            const validation = validateDepositAmount(
              value,
              limits,
              loading,
              currency,
              true,
              isProfileIomRegulatedMarketUnverified,
            );
            if (validation !== true) {
              ctx.addIssue({
                code: "custom",
                message:
                  typeof validation === "string"
                    ? validation
                    : "Enter a valid deposit amount",
              });
            }
          }),
      }),
    [limits, loading, currency, isProfileIomRegulatedMarketUnverified],
  );

  return [schema, loading] as const;
};

export { useDepositAmountValidationSchema };
